import { render, staticRenderFns } from "./CardMealSlider.vue?vue&type=template&id=507669f4"
import script from "./CardMealSlider.vue?vue&type=script&lang=js"
export * from "./CardMealSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports